module.exports = __webpack_public_path__ + "static/media/rasslen.faba9c51.jpg";